const API_BASE = process.env.REACT_APP_API_URL;

export const handleBackendRoute = (path: string) => {
  const backendRoutes = ['/auth/google'];
  
  if (backendRoutes.some(route => path.startsWith(route))) {
    window.location.assign(`${API_BASE}${path}`);
    return true;
  }
  return false;
}; 